import loopback from '../../lib/loopback'
import * as types from '../mutation-types'

const state = {
  lastFetchedTimestamp: null,
  projects: []
}

const getters = {
  projects: state => state.projects
}

const actions = {
    async fetchProjects ({ commit }){ 
      try {
        const projects = await loopback.fetch('Jobs/division-filter', null, {
          filter: JSON.stringify({
              where: {
                  job_status: 'Active'
              },
              fields: [ 'id', 'name' ],
              order: 'name ASC'
          })
        })
        console.log('fetched projects', projects)
        commit(types.PROJECTS, projects.data)
      } catch (error) {
        console.log('error fetching projects - offline?')
      }
    }
}

const mutations = {
  [types.PROJECTS] (state, projects) {
    state.projects = projects
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
